import { Pipe, PipeTransform } from '@angular/core';
import type { SectionRowViewModel } from '../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';

@Pipe({
  name: 'sectionRowViewModelBasicMethod',
  standalone: false
})
export class SectionRowViewModelBasicMethodPipe implements PipeTransform {
  /**
   * @deprecated use MethodPipe instead
   */
  transform(sectionRowViewModel: SectionRowViewModel, methodKey: string, ...params: any[]): any {
    return sectionRowViewModel?.[methodKey]?.(...params);
  }
}
